// Values the server calculates for written rows, keyed by row number, laid over the rows the table shows.
export type RowPatches = Record<string, object>;

export const patchRows = <Row extends { rowNumber: number }>(rows: Row[], patches: RowPatches): Row[] =>
  rows.map(row => (patches[row.rowNumber] ? { ...row, ...patches[row.rowNumber] } : row));
